// extracted by mini-css-extract-plugin
export default {"cardItem":"Badge_cardItem__7gKiQ","cardItemTextOnly":"Badge_cardItemTextOnly__8RXvL","cardBadge":"Badge_cardBadge__IO2ya","cardTag":"Badge_cardTag__qAWnE"};